import React, { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { UserInsightsWrapper } from "./styled";
import { CompaniesWrapperStyles } from "pages/Companies/styled";
import Icon from "components/Icon/Icon";
import { useDispatch, useSelector } from "react-redux";
import CreatorStats from "./CreatorStats";
import { useUsersSlice } from "../slice/index";
import { selectMarketUser } from "../slice/selectors";
import { formatDate } from "../data";
import MarketplaceStats from "./MarketplaceStats";

const Field = ({ label, value, type, user }) => {
  const isValidValue =
    value !== null &&
    value !== undefined &&
    value !== "" &&
    typeof value !== "object";

  return (
    <div className="field-wrapper">
      <p className="field-label">{label}</p>

      {type === "email" ? (
        isValidValue ? (
          <a className="field-value email" href={`mailto:${value}`}>
            {value}
          </a>
        ) : (
          <p className="field-value">-</p>
        )
      ) : (
        <p className="field-value">{isValidValue ? String(value) : "-"}</p>
      )}
    </div>
  );
};

const UserInsights = () => {
  const { userId } = useParams();
  const { actions: userActions } = useUsersSlice();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // selectMarketUser returns { loading, error, data }
  const { data: user, loading: userLoading } = useSelector(selectMarketUser);

  useEffect(() => {
    if (!userId) return;
    dispatch(userActions.fetchUserById({ userId }));
  }, [userId]);

  const handleGoBack = () => {
    navigate(`/marketer-users${location.search}`);
  };

  return (
    <UserInsightsWrapper>
      <CompaniesWrapperStyles>
        <div className="go-back-wrapper">
          <div className="go-back-icon" onClick={handleGoBack}>
            <Icon component={ArrowLeftIcon} format="outline" weight="regular" />
          </div>
          <div className="update-text-wrapper">
            <h4 className="truncate-text">User Insights</h4>
          </div>
        </div>
      </CompaniesWrapperStyles>

      <div className="container-wrapper">
        {/* ── User Details ── */}
        <section className="insights-section">
          <h5 className="header">User Details</h5>

          <div className="wrapper">
            <div className="user-details-left">
              <Field
                label="Name"
                value={
                  user?.first_name || user?.last_name
                    ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
                    : "-"
                }
              />
              <Field
                label="Email"
                type="email"
                user={user}
                value={user?.email}
              />
              <Field label="Status" value={user?.status} />
            </div>
            <div className="user-details-right">
              <Field
                label="Phone verified at"
                value={formatDate(user?.phone_verified_at)}
              />
              <Field
                label="Email verified at"
                value={formatDate(user?.email_verified_at)}
              />
              <Field
                label="Last active at"
                value={formatDate(user?.last_active_at)}
              />
            </div>
          </div>
        </section>

        {/* ── Creator Stats ── */}
        <section className="insights-section">
          <h5 className="header">Creator Stats</h5>
          <CreatorStats />
        </section>

        {/* ── Marketplace Stats ── */}
        <section className="insights-section">
          <h5 className="header">Marketplace Stats</h5>
          <MarketplaceStats />
        </section>
      </div>
    </UserInsightsWrapper>
  );
};

export default UserInsights;
